var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.34241C15 4.0263 14.8768 3.72911 14.6532 3.50514C14.4295 3.28154 14.1321 3.1582 13.8158 3.1582C13.4995 3.1582 13.2021 3.28157 12.9784 3.50514L7.49994 8.98368L2.02148 3.50514C1.7978 3.28154 1.50041 3.1582 1.18412 3.1582C0.867832 3.1582 0.57041 3.28157 0.346758 3.50514C0.123105 3.7287 0 4.0263 0 4.34241C0 4.65853 0.123076 4.95612 0.346641 5.17969L6.66258 11.4955C6.88626 11.7191 7.18365 11.8424 7.49994 11.8424C7.81623 11.8424 8.11365 11.7191 8.3373 11.4955L14.6531 5.17969C14.8768 4.95571 15 4.6585 15 4.34241Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/drop-down-arrow.ae050a4a883b2aa8a774ca56b663fc51.svg";
export { ForwardRef as ReactComponent };